















































































































































import { Vue, Component } from "vue-property-decorator";
import { ApplicantList } from "@/modules/applicants/types";
import dayjs from "dayjs";
import Loader from "@/modules/externals/components/Loader.vue";
import { namespace } from "vuex-class";
import { AxiosResponse } from "node_modules/axios";
import TableHeader from "@/modules/externals/components/TableHeader.vue";
import TableLoader from "@/modules/externals/components/TableLoader.vue";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

const Business = namespace("business");

@Component({
  components: {
    loader: Loader,
    "table-header": TableHeader,
    "table-loader": TableLoader,
  },
})
export default class UBOTable extends Vue {
  @Business.Getter("getCurrentBusinessOwners")
  currentBusinessOwners: ApplicantList;
  @Business.Getter("getSortOrder")
  sortOrder: string;
  @Business.Action("setSortOrder")
  setSortOrder!: (sortOrder: string) => void;
  @Business.Action("setSortBy")
  setSortBy!: (sortBy: string) => void;
  @Business.Action("fetchCurrentBusinessOwners")
  fetchCurrentBusinessOwners!: (businessId: string) => Promise<AxiosResponse>;
  @Business.Getter("getSortBy") sortBy: string;
  @Business.Getter("getIsFetchingBusinessOwners")
  isFetchingBusinessOwners: boolean;

  localDate(date: string) {
    return dayjs(date).format("MMM D YYYY");
  }
  localTime(date: string) {
    return dayjs(date).subtract(5, "hour").format("h:mm a");
  }

  async mounted() {
    const businessId = this.$route.params.businessId;
    if (businessId) await this.fetchCurrentBusinessOwners(businessId);
  }

  async sort(sortBy, sortOrder) {
    this.setSortOrder(sortOrder);
    this.setSortBy(sortBy);
    const businessId = this.$route.params.businessId;
    if (businessId) await this.fetchCurrentBusinessOwners(businessId);
  }
}
